import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const PriceContainer = styled.div`
  color: ${COLORS.error};
  font-size: 14px;
  margin: 15px 0;
`;

export default PriceContainer;
